import React from 'react';
import { useIsRequiredElement } from '../../../hook/useIsRequiredElement';
import ElementErrorMessage from './components/element-error-message';
import { GridYValue, GridYUnit } from '../../../constants';

export const SingleLineHeaderElement = function FromElement({ element, handlerChange, error, formHasOnlyOneSubmitter }) {
  const isRequiredElement = useIsRequiredElement(element, formHasOnlyOneSubmitter);
  return (
    <>
      <label
        htmlFor={element.id}
        className="form-label"
        style={{ zIndex: 5000 + (element.options.zIndex || 10), width: 'fit-content', position: 'relative' }}
      >
        {element.options.label} <span className="required">{isRequiredElement ? '*' : ''}</span>
      </label>
      <input
        readOnly={element.options.readOnly}
        value={element.options.valueInput.trimStart()}
        onChange={(e) => handlerChange(element, e.target.value)}
        name={element.options.name}
        id={element.id}
        type="text"
        className={`form-control form-control-${element.options.size}`}
        style={{
          width: '100%',
          height: element.options.innerElemHeight * GridYValue + GridYUnit,
          zIndex: 5000 + (element.options.zIndex || 10),
          position: 'relative',
          minHeight: 'unset',
        }}
      />
      <ElementErrorMessage message={error} />
      {element.options.instructions && <p className="instructions">{element.options.instructions}</p>}
    </>
  );
};
